export const GameModes = {
  LEARN: "LEARN",
  TEST: "TEST",
};
